<div mat-dialog-title>
  <div class="d-flex align-items-center justify-content-center">
    <div>New Task</div>
    <fa-icon [icon]="faPlus"></fa-icon>
  </div>
</div>
<div mat-dialog-content>
  <div class="container-fluid">
    <strong>Give your task a name</strong>
    <mat-form-field class="w-100" appearance="standard">
      <mat-label>Project Name</mat-label>
      <input [(ngModel)]="taskModel.task.name" type="text" matInput placeholder="Task Name..."
             [formControl]="taskNameFormControl" [errorStateMatcher]="matcher">
      <span matSuffix>
        <fa-icon [icon]="faEdit"></fa-icon>
      </span>
      <mat-error *ngIf="taskNameFormControl.hasError('required')">
        A task name is <strong>required</strong>
      </mat-error>
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions class="project-create-footer">
  <div class="w-100 d-flex justify-content-end">
    <button mat-raised-button (click)="confirm()" color="accent" type="submit"
            >
      Start
    </button>
    <button mat-raised-button (click)="cancel()" color="" type="submit"
            >
      Back
    </button>
  </div>
</div>
